import axios from "../api/axiosInstance";

export const getPaymentHistory = (customerRef) => {
  return axios.get(`/PaymentHistory/${customerRef}`);
};